import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'

import MerchandiseCodeActions from '../reducers/merchandiseCodeReducer'

export function* getMerchandiseCodes() {
  try {
    const dbRef = firebase.firestore().collection('merchandise_codes')

    const snapshot = yield call([dbRef, dbRef.get])
    const merchandiseCodes = {}

    snapshot.forEach(doc => {
      merchandiseCodes[doc.id] = { ...doc.data(), id: doc.id }
    })

    yield put(MerchandiseCodeActions.setMerchandiseCodes(merchandiseCodes))
  } catch (error) {
    //
  }
}

export function* saveMerchandiseCode({ params, callback }) {
  try {
    const doc = firebase.firestore().collection('merchandise_codes').doc(params.merchant_id)

    yield call([doc, doc.set], params)
    yield put(MerchandiseCodeActions.setMerchandiseCode({ ...params, id: doc.id }))

    yield call(callback)
  } catch (err) {
    // eslint-disable-next-line no-alert
    alert(err)
  }
}


// WEBPACK FOOTER //
// ./src/sagas/merchandiseCodeSaga.js